import { isSameDay, startOfToday } from 'date-fns';

export const calculateMinTime = date => (isSameDay(date, new Date()) ? new Date() : startOfToday());
